"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Skeleton = void 0;
const flora_react_1 = require("@grupoboticario/flora-react");
const shine = (0, flora_react_1.keyframes)({
    '0%': {
        backgroundPosition: '-200px 0',
    },
    '100%': {
        backgroundPosition: 'calc(200px + 100%) 0',
    },
});
exports.Skeleton = (0, flora_react_1.styled)(flora_react_1.Box, {
    display: 'inline-block',
    background: '#f6f7f8',
    backgroundImage: 'linear-gradient(90deg, #f6f7f8 0px, #edeef1 40px, #f6f7f8 80px)',
    backgroundSize: '200px 100%',
    backgroundRepeat: 'no-repeat',
    animation: `${shine} 1.2s infinite linear`,
    borderRadius: '$4',
    margin: '$0.5 0',
});
